import {
  BeneficiaryInsightDisplayType,
  BeneficiaryInsightWidgetDTO,
} from '@repo/shared/dtos/beneficiary'
import { BarChart3, ChartSpline, Gauge, PieChart } from 'lucide-react'

export function getInsightWidgetIcon(widget: BeneficiaryInsightWidgetDTO) {
  return getInsightIcon(widget.type)
}

export function getInsightIcon(type: BeneficiaryInsightDisplayType, className?: string) {
  switch (type) {
    case 'kpi':
      return <Gauge className={className} />
    case 'pie':
      return <PieChart className={className} />
    case 'bar':
      return <BarChart3 className={className} />
    case 'line':
      return <ChartSpline className={className} />
  }
}
